<template>
  <div class="page">
    <div class="workspace">
      <div class="ws-unit">
        <div class="ws-unit-header ">
          <div>
            <el-button type="primary" size="small" round icon="el-icon-plus" @click="create">添加</el-button>
          </div>
          <div class="ws-unit-toolbar">
          </div>
        </div>
        <div class="ws-unit-body">
          <category-table ref="table"/>
        </div>
      </div>
    </div>
    <category-form @success="onCategorySaveSuccess" ref="dialog" />
  </div>
</template>

<script>
import CategoryTable from "./Table";
import CategoryForm from "./Form";

export default {
    name: "Product",
    components: {
        CategoryTable,
        CategoryForm
    },
    methods:{
        create(){
            this.$refs.dialog.show();
        },
        onCategorySaveSuccess(){
            this.$refs.table.loadData();
        }
    }

}
</script>

<style scoped>

</style>